export var AttendanceStatus;
(function (AttendanceStatus) {
    /** There is no available attendance information. */
    AttendanceStatus["NOT_SET"] = "NOT_SET";
    /** At least a single participant attended the session. */
    AttendanceStatus["ATTENDED"] = "ATTENDED";
    /** No participants attended the session. */
    AttendanceStatus["NOT_ATTENDED"] = "NOT_ATTENDED";
})(AttendanceStatus || (AttendanceStatus = {}));
/**
 * Multi service booking will be considered available if its bookings are available as returned from ListMultiServiceAvailabilityTimeSlots API.
 * Currently, `SEPERATE_BOOKINGS` and `PARALLEL_BOOKINGS` are not supported.
 * Multi service booking will be considered available if each of its bookings is available separately.
 * For `SEQUENTIAL_BOOKINGS`, see [List Multi Service Availability Time Slots] (url) documentation // todo: complete url
 */
export var MultiServiceBookingType;
(function (MultiServiceBookingType) {
    MultiServiceBookingType["SEQUENTIAL_BOOKINGS"] = "SEQUENTIAL_BOOKINGS";
    MultiServiceBookingType["SEPARATE_BOOKINGS"] = "SEPARATE_BOOKINGS";
    MultiServiceBookingType["PARALLEL_BOOKINGS"] = "PARALLEL_BOOKINGS";
})(MultiServiceBookingType || (MultiServiceBookingType = {}));
export var LocationType;
(function (LocationType) {
    LocationType["UNDEFINED"] = "UNDEFINED";
    LocationType["OWNER_BUSINESS"] = "OWNER_BUSINESS";
    LocationType["OWNER_CUSTOM"] = "OWNER_CUSTOM";
    LocationType["CUSTOM"] = "CUSTOM";
})(LocationType || (LocationType = {}));
export var ValueType;
(function (ValueType) {
    /** Short text. This is the default value type. */
    ValueType["SHORT_TEXT"] = "SHORT_TEXT";
    /** Long text. */
    ValueType["LONG_TEXT"] = "LONG_TEXT";
    /** A text that represents the check box value. If selected the value is `true`, otherwise `false`. */
    ValueType["CHECK_BOX"] = "CHECK_BOX";
})(ValueType || (ValueType = {}));
/** Booking status. */
export var BookingStatus;
(function (BookingStatus) {
    /** The booking was created. */
    BookingStatus["CREATED"] = "CREATED";
    /** The booking was confirmed. */
    BookingStatus["CONFIRMED"] = "CONFIRMED";
    /** The booking was canceled. */
    BookingStatus["CANCELED"] = "CANCELED";
    /** The booking is waiting to be confirmed or declined by the business owner. */
    BookingStatus["PENDING"] = "PENDING";
    /** The booking was declined by the business owner. */
    BookingStatus["DECLINED"] = "DECLINED";
    /** The booking is on a wait list. */
    BookingStatus["WAITING_LIST"] = "WAITING_LIST";
})(BookingStatus || (BookingStatus = {}));
/**
 * Payment status.
 * Automatically updated when using eCom checkout APIs.
 */
export var PaymentStatus;
(function (PaymentStatus) {
    /** Undefined payment status. */
    PaymentStatus["UNDEFINED"] = "UNDEFINED";
    /** The booking is not paid for. */
    PaymentStatus["NOT_PAID"] = "NOT_PAID";
    /** The booking is fully paid. */
    PaymentStatus["PAID"] = "PAID";
    /** The booking is partially paid. */
    PaymentStatus["PARTIALLY_PAID"] = "PARTIALLY_PAID";
    /** The booking is refunded. */
    PaymentStatus["REFUNDED"] = "REFUNDED";
    /** The booking is free of charge. */
    PaymentStatus["EXEMPT"] = "EXEMPT";
})(PaymentStatus || (PaymentStatus = {}));
/**
 * The selected payment option.
 * One of the payment options offered by the service.
 * This field is be set when the user selects an option during booking.
 * If left undefined, the payment option is resolved by the service configuration on checkout.
 */
export var SelectedPaymentOption;
(function (SelectedPaymentOption) {
    /** Undefined payment option. */
    SelectedPaymentOption["UNDEFINED"] = "UNDEFINED";
    /** Offline payment. */
    SelectedPaymentOption["OFFLINE"] = "OFFLINE";
    /** Online payment. */
    SelectedPaymentOption["ONLINE"] = "ONLINE";
    /** Payment using a membership. */
    SelectedPaymentOption["MEMBERSHIP"] = "MEMBERSHIP";
    /** Payment can only be done using a membership and must be manually redeemed in the dashboard by the site owner. */
    SelectedPaymentOption["MEMBERSHIP_OFFLINE"] = "MEMBERSHIP_OFFLINE";
})(SelectedPaymentOption || (SelectedPaymentOption = {}));
export var Platform;
(function (Platform) {
    Platform["UNDEFINED_PLATFORM"] = "UNDEFINED_PLATFORM";
    Platform["WEB"] = "WEB";
    Platform["MOBILE_APP"] = "MOBILE_APP";
})(Platform || (Platform = {}));
export var Actor;
(function (Actor) {
    Actor["UNDEFINED_ACTOR"] = "UNDEFINED_ACTOR";
    Actor["BUSINESS"] = "BUSINESS";
    Actor["CUSTOMER"] = "CUSTOMER";
})(Actor || (Actor = {}));
export var IdentityType;
(function (IdentityType) {
    IdentityType["UNKNOWN"] = "UNKNOWN";
    IdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    IdentityType["MEMBER"] = "MEMBER";
    IdentityType["WIX_USER"] = "WIX_USER";
    IdentityType["APP"] = "APP";
})(IdentityType || (IdentityType = {}));
export var BookingFeeStatus;
(function (BookingFeeStatus) {
    BookingFeeStatus["UNKNOWN_STATUS"] = "UNKNOWN_STATUS";
    BookingFeeStatus["NOT_YET_APPLIED_TO_ORDER"] = "NOT_YET_APPLIED_TO_ORDER";
    BookingFeeStatus["APPLIED_TO_ORDER"] = "APPLIED_TO_ORDER";
})(BookingFeeStatus || (BookingFeeStatus = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
//# sourceMappingURL=types.impl.js.map